const UNKNOWN_WORDS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default UNKNOWN_WORDS_INITIAL_STATE
